(function () {
  'use strict';

  // @ngInject
  function CoronaTitleSecondLevelNavigationControllerCtor($scope, $injector, moment, $state) {
    this.constructor.$super.call(this, $scope, $injector);
    this.__objectType = 'CoronaTitleSecondLevelNavigationController';

    this.$state = $state;
    this.title = this.$state.$current.data.title;
    this.date = moment().format('ddd, MMM DD, YYYY');
  }

  Controllers.CoronaTitleSecondLevelNavigationController = Class(Controllers.BaseController, {
    constructor: CoronaTitleSecondLevelNavigationControllerCtor
  });
}());